import script from "./CommunitySiteArticleSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunitySiteArticleSearch.vue?vue&type=script&setup=true&lang=ts"

import "./CommunitySiteArticleSearch.vue?vue&type=style&index=0&id=41a606cd&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a606cd"]])

export default __exports__